import * as React from 'react';
import { clsx } from 'clsx';
import { UIText1 } from '@cian/ui-kit';

import { InsideIcon } from '../../InsideIcon';
import { DepartmentLink, RateMark } from '../parts';

import * as styles from './InfrastructureFromBuilder.css';

export interface IInfrastructureTerm {
  done: boolean;
  title: string;
}

export interface IInfrastructureFromBuilderProps {
  departmentLink: string;
  maxRate: string;
  rate: string;
  terms: IInfrastructureTerm[];
}

export const InfrastructureFromBuilder: React.FC<IInfrastructureFromBuilderProps> = ({
  departmentLink,
  maxRate,
  rate,
  terms,
}) => {
  return (
    <>
      <div className={styles['department-link-wrapper']}>
        <DepartmentLink departmentLink={departmentLink} />
      </div>
      <div className={styles['rate-mark-wrapper']}>
        <RateMark icon={<InsideIcon />} maxRate={maxRate} rate={rate} />
      </div>
      <ul className={styles['terms']} data-testid="InfrastructureFromBuilderTerms">
        {terms.map((term, idx) => (
          <li key={idx} className={clsx(styles['term-item'], term.done && styles['term-item--done'])}>
            <UIText1 color="current_color">{term.title}</UIText1>
          </li>
        ))}
      </ul>
    </>
  );
};
